import React from 'react'
import Header from './components/Header';
import Hero from './components/Hero';
import Clients from './components/Clients';
import Services from './components/Services';
import Cases from './components/Cases';
import Technologies from './components/Technologies';
import Comments from './components/Comments'
import Footer from './components/Footer';

function App() {
  return (
    <div className='wrapper-hero'>
      <Header/>
      <Hero/>
      <Clients/>
      <div className='wrapper-services'>
        <Services/>
        <div className='wrapper-cases'>
          <Cases/>
          <div className='wrapper-tech'>
            <Technologies/>
            <Comments />
            <Footer/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
